module.exports = __webpack_public_path__ + "img/15.aa59ef1a.jpg";